import { Space, Tag } from 'antd';
import dayjs from 'dayjs';
import {
    CalendarDays,
    Clock1,
    Clock2,
    Clock3,
    Clock4,
    Clock5,
    Clock6,
    Clock7,
    Clock8,
    Clock9,
    Clock10,
    Clock11,
    Clock12,
    Clock,
} from 'lucide-react';

const DateTimeTag = ({ date, size = 14 }) => {
    const clockIcons = {
        1: <Clock1 size={size} />,
        2: <Clock2 size={size} />,
        3: <Clock3 size={size} />,
        4: <Clock4 size={size} />,
        5: <Clock5 size={size} />,
        6: <Clock6 size={size} />,
        7: <Clock7 size={size} />,
        8: <Clock8 size={size} />,
        9: <Clock9 size={size} />,
        10: <Clock10 size={size} />,
        11: <Clock11 size={size} />,
        12: <Clock12 size={size} />,
    };

    const hour = dayjs(date).format('h');
    const clockIcon = clockIcons[hour] || <Clock size={size} />;

    return (
        <Space size={4}>
            <Tag className="date-time-tag" icon={<CalendarDays size={size} />}>
                {dayjs(date).format('DD/MM/YYYY')}
            </Tag>
            <Tag className="date-time-tag" icon={clockIcon}>
                {dayjs(date).format('HH:mm')}
            </Tag>
        </Space>
    );
};

export default DateTimeTag;
